import { FaUserCog, FaHandshake, FaTools, FaIndustry } from "react-icons/fa";
import { FaMedal, FaLightbulb, FaHandsHelping } from "react-icons/fa";
import profPic1 from "../../assets/profile_img/jay_prakash.jpg";
import profPic2 from "../../assets/profile_img/bharath.jpg";

export const AboutUsData = {
  heroData: {
    title: "About ",
    title2: "Us",
    subTitle: "Engineering Precision Controlled Atmosphere Solutions",
    imgUrl:
      "https://proresglovebox.com/wp-content/uploads/2025/02/NITK-Surathkal-1.jpg",
  },

  aboutCompany: {
    imgUrl:
      "https://proresglovebox.com/wp-content/uploads/2025/02/NITK-Surathkal-1.jpg",
    title: "ProRes Scientific",
    subTitleOne: "Advancing",
    subTitleTwo: "Contamination-Control",
    subTitleThree: "Through Engineering Excellence",
    description:
      "ProRes Scientific is a specialized manufacturer of advanced glovebox and controlled atmosphere systems, serving research laboratories, industrial facilities, and high-precision manufacturing environments. Our solutions are engineered to deliver unmatched reliability, safety, and performance, supporting critical applications where atmosphere purity is essential.",
    featureList: [
      "Precision Engineered Systems",
      "International Quality Standards",
      "Experienced Engineering Team",
      "Responsive Technical Support",
    ],
    ctaPrimary: "Get in Touch →",
    ctaSecondary: {
      callText: "Speak With Our Experts",
      callNumber: "+91 98446 06132",
    },
  },

  whyChooseUsData: {
    title: "Why ProRes Scientific",
    subTitle: "Our Strengths",
    description:
      "With deep domain expertise and a customer-centric approach, ProRes Scientific delivers glovebox solutions that meet the demanding requirements of modern research and industrial applications.",
    featureList: [
      {
        icon: <FaUserCog size={55} />,
        title: "Specialized Engineering Expertise",
      },
      {
        icon: <FaHandshake size={55} />,
        title: "Long-Term Client Commitment",
      },
      {
        icon: <FaTools size={55} />,
        title: "Lifecycle Support & Maintenance",
      },
      {
        icon: <FaIndustry size={55} />,
        title: "Industry-Ready Manufacturing",
      },
    ],
  },

  missionVission: {
    title: "Our Mission & Vision",
    missionText:
      "Our mission is to design and deliver highly reliable, precision-controlled glovebox systems that empower researchers and manufacturers to achieve consistent results, safeguard sensitive processes, and drive scientific and industrial innovation.",
    visionText:
      "We envision becoming a globally trusted partner in controlled atmosphere technology—where contamination control enables breakthroughs in energy storage, materials science, pharmaceuticals, and advanced manufacturing.",
  },

  coreValues: {
    title: "Our Core Values",
    values: [
      {
        icon: <FaMedal className="text-5xl text-[#ff1a1a]" />,
        title: "Uncompromising Quality",
        desc: "We adhere to rigorous engineering and manufacturing standards to ensure long-term system reliability and safety.",
      },
      {
        icon: <FaLightbulb className="text-5xl text-[#ff1a1a]" />,
        title: "Innovation & Continuous Improvement",
        desc: "We continuously enhance our designs and technologies to meet evolving scientific and industrial requirements.",
      },
      {
        icon: <FaHandsHelping className="text-5xl text-[#ff1a1a]" />,
        title: "Customer-Centric Partnership",
        desc: "We collaborate closely with our clients, offering technical guidance, customization, and dependable after-sales support.",
      },
    ],
  },

  team: {
    title: "Leadership & Engineering Team",
    list: [
      {
        name: "Mr. Jagadish Sheregar",
        role: "Chief Executive Officer",
        img: profPic1,
      },
      {
        name: "Mr. Bharath",
        role: "Chief Technology Officer",
        img: profPic2,
      },
      // {
      //   name: "Mr. ",
      //   role: "Director of Engineering",
      //   img: profPic2
      // },
    ],
  },
};
